function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M45.53 0H18.48A18.47 18.47 0 000 18.49v27.06A18.47 18.47 0 0018.48 64h27.05A18.47 18.47 0 0064 45.55V18.49A18.47 18.47 0 0045.53 0zm12.58 46a12.26 12.26 0 01-12.26 12.29H18.16A12.26 12.26 0 015.9 46V18.34A12.26 12.26 0 0118.16 6.07h27.69a12.26 12.26 0 0112.26 12.27z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32 15.57a16.61 16.61 0 1016.61 16.61A16.61 16.61 0 0032 15.57zm0 27.37a10.76 10.76 0 1110.77-10.76A10.76 10.76 0 0132 42.94z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 49.17,
  cy: 14.94,
  r: 3.87,
  fill: "currentColor"
});

function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+aW5zdGFncmFtPC90aXRsZT48cGF0aCBkPSJNNDUuNTMsMEgxOC40OEExOC40NywxOC40NywwLDAsMCwwLDE4LjQ5VjQ1LjU1QTE4LjQ3LDE4LjQ3LDAsMCwwLDE4LjQ4LDY0SDQ1LjUzQTE4LjQ3LDE4LjQ3LDAsMCwwLDY0LDQ1LjU1VjE4LjQ5QTE4LjQ3LDE4LjQ3LDAsMCwwLDQ1LjUzLDBaTTU4LjExLDQ2QTEyLjI2LDEyLjI2LDAsMCwxLDQ1Ljg1LDU4LjI5SDE4LjE2QTEyLjI2LDEyLjI2LDAsMCwxLDUuOSw0NlYxOC4zNEExMi4yNiwxMi4yNiwwLDAsMSwxOC4xNiw2LjA3SDQ1Ljg1QTEyLjI2LDEyLjI2LDAsMCwxLDU4LjExLDE4LjM0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PHBhdGggZD0iTTMyLDE1LjU3QTE2LjYxLDE2LjYxLDAsMSwwLDQ4LjYxLDMyLjE4LDE2LjYxLDE2LjYxLDAsMCwwLDMyLDE1LjU3Wm0wLDI3LjM3QTEwLjc2LDEwLjc2LDAsMSwxLDQyLjc3LDMyLjE4LDEwLjc2LDEwLjc2LDAsMCwxLDMyLDQyLjk0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PGNpcmNsZSBjeD0iNDkuMTciIGN5PSIxNC45NCIgcj0iMy44NyIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";
export { SvgInstagram as ReactComponent };